import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useEffect, useState } from "react";
import styles from "./styles.module.css";
import GainfulSlider from "../GainfulSlider";
const SliderComponent = (props) => {
    const leftOption = props.options[0].text;
    const leftValue = props.options[0].value;
    const middleOption = props.options[1].text;
    const middleValue = props.options[1].value;
    const rightOption = props.options[2].text;
    const rightValue = props.options[2].value;
    const [selectedOption, setSelectedOption] = useState(null);
    const [defValue, setDefValue] = useState(50);
    const getValue = () => {
        if (typeof props.answer === "string") {
            return props.answer;
        }
        if (typeof props.answer === "undefined" || props.answer.length === 0) {
            return null;
        }
        return props.answer[0];
    };
    useEffect(() => {
        if (props.answer.constructor === Array && props.answer.length > 0) {
            // this is unforntunately very hacky
            // props.answer will only be an array the very first time this is initialized
            // otherwise it will be a string, so every time after initialization
            // we do not get here. Instead the  defValue is set in sliderChange
            setDefValue(25 + props.options.map((val) => val.value).findIndex((elem) => props.answer.includes(elem)) * 25);
        }
    }, [props.answer]);
    useEffect(() => {
        const answer = getValue();
        if (answer !== null) {
            const previouslySelected = props.options?.find((elem) => elem.value === answer);
            if (typeof previouslySelected === "undefined") {
                return;
            }
            // @ts-ignore
            props.setValue(previouslySelected.value);
            // @ts-ignore
            setSelectedOption(previouslySelected.text);
        }
        else {
            // @ts-ignore
            props.setValue(middleValue);
            // @ts-ignore
            setSelectedOption(middleOption);
        }
    }, [props.answer]);
    // @ts-ignore
    const sliderChange = (event, newValue) => {
        if (newValue < 34 && selectedOption !== leftOption) {
            // @ts-ignore
            setSelectedOption(rightOption);
            // @ts-ignore
            setSelectedOption(leftOption);
            // @ts-ignore
            setSelectedOption(rightOption);
            // @ts-ignore
            props.setValue(leftValue);
        }
        else if (newValue >= 34 && newValue < 67 && selectedOption !== middleOption) {
            // @ts-ignore
            setSelectedOption(rightOption);
            // @ts-ignore
            setSelectedOption(middleOption);
            // @ts-ignore
            setSelectedOption(rightOption);
            // @ts-ignore
            props.setValue(middleValue);
        }
        else if (newValue >= 67 && selectedOption !== rightOption) {
            // @ts-ignore
            setSelectedOption(rightOption);
            // @ts-ignore
            setSelectedOption(rightOption);
            // @ts-ignore
            props.setValue(rightValue);
        }
        setDefValue(newValue);
    };
    return (_jsxs("div", { className: styles.contain, children: [_jsxs("div", { className: styles.textContain, children: [_jsx("span", { className: selectedOption === leftOption ? styles.bold : "", children: leftOption }), _jsx("span", { className: selectedOption === middleOption ? styles.bold : "", children: middleOption }), _jsx("span", { className: selectedOption === rightOption ? styles.bold : "", children: rightOption })] }), selectedOption !== null && _jsx(GainfulSlider, { defaultValue: defValue, onChange: sliderChange })] }));
};
export default memo(SliderComponent);
